import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import StoreRedirect from "./pages/StoreRedirect";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Books from "./pages/Books";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import ArticleDetail from "./pages/ArticleDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import AdminDashboard from "./pages/AdminDashboard";

const ProtectedRoute = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-forest">Loading…</div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const Layout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/store" element={<Layout><StoreRedirect /></Layout>} />
            <Route path="/store/:id" element={<Layout><ProductDetail /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/books" element={<Layout><Books /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/resources" element={<Layout><Resources /></Layout>} />
            <Route path="/blog" element={<Layout><Blog /></Layout>} />
            <Route path="/blog/:slug" element={<Layout><ArticleDetail /></Layout>} />
            <Route path="/login" element={<Layout><Login /></Layout>} />
            <Route path="/register" element={<Layout><Register /></Layout>} />
            <Route path="/checkout/return" element={<Navigate to="/store" replace />} />
            <Route
              path="/account"
              element={<ProtectedRoute><Layout><Account /></Layout></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute admin><Layout><AdminDashboard /></Layout></ProtectedRoute>}
            />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
